import { render, staticRenderFns } from "./EquipmentRelationshipDialog.vue?vue&type=template&id=25c36671&scoped=true&"
import script from "./EquipmentRelationshipDialog.vue?vue&type=script&lang=js&"
export * from "./EquipmentRelationshipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c36671",
  null
  
)

export default component.exports